import { CircularProgress, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import Modal from "../Modals/Modal";
import NormalText from "../Typography/NormalText";
import Button from "../ButtonCustom/ButtonNew";

const ModalStyled = styled(Modal)({
  "& .wrapper": {
    width: "520px",
    maxWidth: "calc(100vw - 48px)",
    maxHeight: "calc(100vh - 48px)",
  },
  "& .title-row": {
    padding: "16px 20px 8px 20px",
  },
  "& .title-text": {
    fontSize: "20px",
    fontWeight: 700,
  },
  "& .body": {
    overflowY: "auto",
  },
});

const BodyStyled = styled("div")({
  padding: "0.5rem 1.5rem 1.5rem",
  "& .afm-check-loading": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
    textAlign: "center",
  },
  "& .afm-check-info": {
    alignSelf: "stretch",
    textAlign: "left",
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gap: "0.5rem 1.5rem",
    padding: "0.75rem 1rem",
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    backgroundColor: "#fff",
  },
  "& .afm-check-label": {
    color: "#757575",
  },
  "& .afm-check-detail": {
    whiteSpace: "pre-line",
  },
  "& .afm-check-actions": {
    display: "flex",
    justifyContent: "flex-end",
    gap: "0.5rem",
    marginTop: "1.5rem",
  },
});

const AfmCheckDialog = ({ afmCheck }) => {
  const { t } = useTranslation();
  const {
    isChecking,
    checkedPerson,
    isNoticeOpen,
    errorType,
    detail,
    confirm,
    cancel,
  } = afmCheck;
  const isTimeout = errorType === "Timeout";

  return (
    <ModalStyled
      isOpen={isChecking || isNoticeOpen}
      onClose={cancel}
      title={
        errorType
          ? t(`AfmCheck.${errorType}Title`)
          : isNoticeOpen
            ? t("AfmCheck.Title")
            : t("AfmCheck.CheckingTitle")
      }
    >
      <BodyStyled>
        {isNoticeOpen ? (
          <>
            <NormalText className="afm-check-detail">
              {errorType ? t(`AfmCheck.${errorType}`) : detail}
            </NormalText>
            <div className="afm-check-actions">
              <Button color="error" onClick={cancel}>
                {isTimeout ? t("AfmCheck.Close") : t("Global.Cancel")}
              </Button>
              {!isTimeout && (
                <Button variant="filled" onClick={confirm}>
                  {t("AfmCheck.Continue")}
                </Button>
              )}
            </div>
          </>
        ) : (
          <div className="afm-check-loading">
            <div className="afm-check-info">
              {checkedPerson?.name && (
                <>
                  <NormalText className="afm-check-label">
                    {t("AfmCheck.Name")}
                  </NormalText>
                  <NormalText>{checkedPerson.name}</NormalText>
                </>
              )}
              <NormalText className="afm-check-label">
                {t("AfmCheck.TaxNumber")}
              </NormalText>
              <NormalText>{checkedPerson?.taxNumber}</NormalText>
            </div>
            <NormalText>{t("AfmCheck.CheckingDescription")}</NormalText>
            <CircularProgress size={28} />
          </div>
        )}
      </BodyStyled>
    </ModalStyled>
  );
};

export default AfmCheckDialog;
